import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.assign.js";
import React from 'react';
import { renderImperatively } from '../../utils/render-imperatively';
import { Dialog } from './dialog';
export var closeFnSet = new Set();
/**
 * 直接打开对话框（指令式）
 */

export function show(props) {
  var handler = renderImperatively( /*#__PURE__*/React.createElement(Dialog, Object.assign({}, props, {
    getContainer: null,
    afterClose: function afterClose() {
      var _a;

      closeFnSet.delete(handler.close);
      (_a = props.afterClose) === null || _a === void 0 ? void 0 : _a.call(props);
    }
  })));
  closeFnSet.add(handler.close);
  return handler;
}